function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M115.311,322.719c-3.502,0.001-6.633-2.464-7.346-6.029c-0.639-3.191-3.623-22.721-3.623-26.506c0-4.143,3.358-7.5,7.5-7.5 c4.129,0,7.478,3.336,7.5,7.46c0.081,2.477,2.577,19.835,3.331,23.603c0.813,4.061-1.82,8.013-5.882,8.826 C116.294,322.671,115.798,322.719,115.311,322.719z M119.342,290.184h0.01H119.342z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M196.94,186.434c-0.79,0-1.593-0.125-2.384-0.389c-3.93-1.31-6.046-5.578-4.737-9.508c0.549-1.647,2.038-4.78,5.388-11.638 c0.926-1.896,1.801-3.688,2.119-4.39c1.708-3.774,6.151-5.449,9.925-3.74c3.773,1.709,5.448,6.152,3.74,9.926 c-0.409,0.903-1.246,2.617-2.306,4.788c-1.467,3.003-4.198,8.594-4.649,9.838C202.989,184.46,200.074,186.434,196.94,186.434z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M231.833,332.558c-1.279,0-2.574-0.327-3.759-1.015c-3.667-2.13-13.912-7.987-17.232-9.501 c-3.769-1.718-5.432-6.165-3.714-9.935s6.165-5.434,9.935-3.714c4.59,2.092,17.129,9.355,18.544,10.177 c3.582,2.08,4.8,6.67,2.72,10.252C236.934,331.22,234.418,332.558,231.833,332.558z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M180.444,458.325c-4.142,0-7.5-3.357-7.5-7.5c0-4.133-1.079-19.716-1.598-27.205c-0.166-2.404-0.292-4.22-0.34-5.013 c-0.247-4.135,2.904-7.688,7.039-7.934c4.145-0.273,7.687,2.904,7.935,7.038c0.046,0.771,0.168,2.535,0.33,4.873 c0.791,11.413,1.634,23.949,1.634,28.241C187.944,454.968,184.586,458.325,180.444,458.325z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M328.574,327.64c-3.093,0-5.988-1.928-7.074-5.011c-1.376-3.906,0.676-8.189,4.582-9.565 c2.874-1.012,9.618-5.054,14.081-7.728c6.528-3.912,8.695-5.17,10.838-5.599c4.06-0.809,8.014,1.821,8.826,5.883 c0.762,3.808-1.505,7.518-5.137,8.637c-1.122,0.533-4.395,2.495-6.816,3.946c-5.862,3.513-12.506,7.493-16.808,9.009 C330.242,327.502,329.401,327.64,328.574,327.64z M353.954,314.444c-0.003,0-0.006,0.001-0.009,0.002 C353.948,314.445,353.951,314.444,353.954,314.444z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var SvgBaby = function SvgBaby(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M458.281,61.22c-1.919,0-3.839-0.732-5.303-2.196c-2.929-2.93-2.929-7.678,0-10.607l13.22-13.22 c9.902-9.902,22.245-17.201,35.693-21.107c3.979-1.158,8.139,1.133,9.294,5.11c1.155,3.979-1.133,8.139-5.111,9.294 c-11.028,3.203-21.149,9.187-29.27,17.309l-13.22,13.221C462.12,60.487,460.2,61.22,458.281,61.22z"
  }), React.createElement("circle", {
    style: {
      fill: "#F5D7B7"
    },
    cx: 264.39,
    cy: 52.15,
    r: 52.15
  }), React.createElement("circle", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    cx: 264.39,
    cy: 52.15,
    r: 52.15
  }), React.createElement("circle", {
    style: {
      fill: "#F5D7B7"
    },
    cx: 459.85,
    cy: 247.61,
    r: 52.15
  }), React.createElement("circle", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    cx: 459.85,
    cy: 247.61,
    r: 52.15
  }), React.createElement("circle", {
    style: {
      fill: "#38648C"
    },
    cx: 100.47,
    cy: 411.53,
    r: 100.47
  }), React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M171.509,482.574c39.235-39.235,39.235-102.848,0-142.083 s-102.848-39.235-142.083,0C13.905,356.011,4.55,375.35,1.309,395.482c8.178,5.816,19.606,11.453,35.092,17.443 c13.081,5.059,29.064,10.312,47.151,15.523c5.211,18.087,10.464,34.07,15.523,47.151c5.99,15.486,11.627,26.915,17.442,35.093 C136.65,507.449,155.989,498.094,171.509,482.574z"
  }), React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.4557 298.4876)",
    style: {
      fill: "#F5D7B7"
    },
    cx: 358.579,
    cy: 153.415,
    rx: 153.979,
    ry: 150.609
  }), React.createElement("g", null, React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 14.9518 237.3094)",
    style: {
      fill: "#F28B74"
    },
    cx: 293.934,
    cy: 100.606,
    rx: 24.405,
    ry: 30.646
  }), React.createElement("ellipse", {
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 856.5004 81.3777)",
    style: {
      fill: "#F28B74"
    },
    cx: 411.396,
    cy: 218.076,
    rx: 24.405,
    ry: 30.646
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M335.657,112.271c-1.919,0-3.839-0.732-5.303-2.196c-2.929-2.93-2.929-7.678,0-10.607 c1.338-1.338,2.075-3.117,2.075-5.01c0-1.894-0.737-3.673-2.075-5.011c-1.339-1.34-3.118-2.076-5.011-2.076 c-1.893,0-3.672,0.736-5.011,2.075c-2.929,2.93-7.677,2.929-10.607,0.001c-2.929-2.929-2.929-7.678,0-10.607 c4.172-4.173,9.719-6.47,15.618-6.47c5.9,0,11.447,2.297,15.618,6.47c4.171,4.171,6.468,9.718,6.468,15.617 c0,5.898-2.297,11.445-6.469,15.617C339.496,111.539,337.577,112.271,335.657,112.271z"
  }), React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M427.857,204.472c-1.919,0-3.839-0.732-5.303-2.196c-2.929-2.93-2.929-7.678,0-10.607 c1.338-1.338,2.075-3.118,2.075-5.011s-0.737-3.673-2.075-5.011c-2.764-2.765-7.259-2.765-10.022,0 c-2.929,2.928-7.678,2.928-10.607,0c-2.929-2.93-2.929-7.678,0-10.607c8.611-8.611,22.623-8.611,31.235,0 c4.171,4.172,6.469,9.719,6.469,15.618s-2.297,11.446-6.469,15.618C431.696,203.739,429.776,204.472,427.857,204.472z"
  }), React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M368.914,171.102c-7.411,0-14.543-2.932-19.814-8.202c-5.726-5.726-8.691-13.65-8.136-21.742 c0.284-4.133,3.87-7.257,7.996-6.969c4.132,0.283,7.252,3.863,6.969,7.996c-0.258,3.765,1.119,7.449,3.777,10.107 c2.66,2.66,6.342,4.03,10.108,3.778c4.13-0.269,7.713,2.836,7.997,6.968c0.284,4.133-2.836,7.713-6.968,7.997 C370.198,171.08,369.555,171.102,368.914,171.102z"
  })), React.createElement("path", {
    style: {
      opacity: 0.05,
      enableBackground: "new"
    },
    d: "M317.674,7.63c-23.934,7.177-46.577,20.277-65.59,39.29 c-60.132,60.132-61.198,156.559-2.381,215.377c34.102,34.102,80.846,48.069,125.83,42.069 C279.545,272.489,250.148,112.211,317.674,7.63z"
  }), React.createElement("path", {
    style: {
      fill: "#76B7EB"
    },
    d: "M130.184,220.867c61.316,0.735,199.893,15.334,279.674,56.98c12.45,6.499,18.08,21.222,13.145,34.371 c-12.513,33.339-45.535,82.599-75.761,112.234c-15.281,14.983-36.257,22.791-57.624,21.576 c-84.319-4.794-270.36-47.62-283.914-75.374C-8.063,342.463,35.186,269.926,86.883,233.99 C99.565,225.174,114.74,220.682,130.184,220.867z"
  }), React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M130.184,220.867c61.316,0.735,199.893,15.334,279.674,56.98 c12.45,6.499,18.08,21.222,13.145,34.371c-12.513,33.339-45.535,82.599-75.761,112.234c-15.281,14.983-36.257,22.791-57.624,21.576 c-84.319-4.794-270.36-47.62-283.914-75.374C-8.063,342.463,35.186,269.926,86.883,233.99 C99.565,225.174,114.74,220.682,130.184,220.867z"
  }), React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M86.883,233.99c-13.25,9.21-25.941,20.828-37.264,33.484 c5.231,38.543,14.236,84.907,25.198,128.488c0.748,2.975,1.501,5.902,2.257,8.802c64.902,19.877,158.005,37.989,211.477,41.196 c2.294-2.947,4.498-5.927,6.591-8.937c11.266-16.209,17.094-35.387,16.853-55.459c-0.319-26.674-3.846-81.702-14.215-140.88 c-64.025-13.762-130.187-19.371-167.594-19.819C114.74,220.682,99.565,225.174,86.883,233.99z"
  }), React.createElement("path", {
    style: {
      fill: "#76B7EB"
    },
    d: "M291.133,381.816c-0.734-61.316-15.334-199.893-56.98-279.674 c-6.499-12.45-21.222-18.08-34.371-13.145c-33.339,12.513-82.599,45.535-112.234,75.761c-14.983,15.281-22.791,36.257-21.576,57.624 c4.794,84.319,47.62,270.36,75.374,283.914c28.191,13.768,100.729-29.481,136.665-81.178 C286.826,412.435,291.318,397.26,291.133,381.816z"
  }), React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _ref2, _ref3, _ref4, _ref5, _ref6), _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBaby, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/baby.6f191e6f.svg";
export { ForwardRef as ReactComponent };